import React from "react";
import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";
import { colors } from "./colors";

export type LinkVariant = "default" | "navigation" | "action";

interface LinkProps extends Omit<MuiLinkProps, "variant"> {
  children: React.ReactNode;
  variant?: LinkVariant;
}

const Link: React.FC<LinkProps> = ({
  variant = "default",
  children,
  sx,
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "navigation":
        return {
          color: colors.neutral.white,
          fontFamily: "Outfit, sans-serif",
          fontSize: "0.875rem",
          fontWeight: 400,
          textDecoration: "none",
          padding: "0.5rem 1rem",
          borderRadius: "4px",
          display: "inline-block",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: colors.neutral[300],
            color: colors.background[900],
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.primary[500]}`,
            outlineOffset: "2px",
          },
        };
      case "action":
        return {
          color: colors.error[400],
          fontFamily: "Outfit, sans-serif",
          fontSize: "1rem",
          fontWeight: 600,
          textDecoration: "none",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          "&:hover": {
            textDecoration: "underline",
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.primary[500]}`,
            outlineOffset: "2px",
          },
        };
      default:
        return {
          color: colors.neutral.white,
          fontFamily: "Outfit, sans-serif",
          fontSize: "0.875rem",
          fontWeight: 400,
          textDecoration: "none",
          "&:hover": {
            color: colors.primary[500],
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.primary[500]}`,
            outlineOffset: "2px",
          },
        };
    }
  };

  return (
    <MuiLink
      {...props}
      sx={{
        ...getVariantStyles(),
        ...sx,
      }}
    >
      {children}
    </MuiLink>
  );
};

export default Link;
